// API VERSION NUMBER
export const API_VERSION_NUMBER = "v4";

/** API Endpoints */
export const GET_SAAS_ADMIN_LIST = "api/saas";
export const GET_SAAS_ADMIN_PAYMENT_SUMMARY_LIST = "api/saas/payments/summary";
export const GET_SASS_PAYMENT = "api/saas/payments";
export const GET_UPLOAD_URL = "signature";
export const SESSION = "session";
export const UPDATE_SASS_PAYMENT = "api/saas/payments";
export const RESET_PASSWORD_URL = "api/public/auth/reset-token-verification";
export const GET_USER_LIST = "api/users/admin";
export const UPDATE_USER = "api/users/admin";
export const CREATE_USERS = "api/users/admin";
export const GET_ADMIN_LIST = "api/users/admin";
export const CATEGOIRES_NOT_NESTED = "api/categories";
export const DENTIST_PROFILE = "/api/users/dentist";
export const ADMIN_PROFILE = "/api/users/admin";
export const SUB_CATEGORIES_LIST = "api/subcategories";
export const MARK_FAVOURAITE = "api/dentist/favourite";
export const NOTES = "api/dentist/notes";
export const CHANGE_PASSWORD = "api/auth/change-pwd";
export const ACCOUNTS = "api/users/dentist";

export const editAccount = "api/users/dentist";
export const LOGOUT = "api/public/auth/logout";
export const CATEGORIES = "api/categories?fetchNested=true";
export const FORGOT_PSWD = "/api/public/auth/forgot-pwd";
export const EMAIL_VALIDATE = "api/public/auth/check-email";
export const COURSES = "/api/courses";
export const SPEAKERS = "api/speakers";
export const SUB_CATEGORIES = "api/categories";
export const REARRANGE_COURSES = "api/courses/rearrange";
export const COURSEBY_CATEGORY = "api/courses/categories";
export const REARRANGE_CATEGORY = "api/categories/rearrange";
export const SEND_CREDS = "api/send/cred";
export const SAAS_CSV = "api/saas/export";
export const CREATE_ACCOUNT_BY_PROFILE = "api/dentist/authorizenet-id";
export const ADMIN_MANAGE_SUBSCRIPTION = "api/subscriptions";
export const DENTIST_SUBSCRIPTION = "api/dentist/subscriptions";
export const ADMIN_SUBSCRIPTION_LIST = "api/subscriptions";
export const DENTIST_COURSES = "api/courses/categories";
export const UPLOAD_IMAGE_QUESTIONNAIRE = "api/upload/image";
export const SUBSCRIPTIONCSV = "api/subscriptions/export";
export const CREATE_SUBSCRIPTION = "api/subscriptions/create";
export const CANCEL_SUBSCRIPTION = "api/subscriptions/cancel";
export const REFRESH_TOKEN = "api/public/refresh/token";
export const FILE_UPLOAD = "api/file/upload";
export const PROGRAM_REGISTER = "api/dentist/payment/profile";
export const CE_REQUEST = "api/request/ceCredit";
export const PURCHASE_PROGRAM = "api/dentist/purchase/program";
export const PURCHASE_COURSE = "api/dentist/purchase/course";
export const S3_SIGN = "api/signature/s3";
export const DENTIST_SIGNUP = "api/public/auth/dentist-signup";
// export const EMAIL_OTP_VERIFY = "api/public/auth/email-otp-verify";
// export const EMAIL_OTP_RESEND = "api/public/auth/email-otp-resend";
export const DENTIST_PROFILE_UPDATE = "api/dentist/profile";
export const CATEGORY_SUBSCRIBE = "api/dentist/category/subscribe";
export const ADMIN_FAILED_SUBSCRIPTION_LIST = "api/failed-subscriptions";
export const START_ATTEMPT = (id, type = "categories") =>
  `api/${type}/${id}/answers`;
export const SUBMIT_ANSWER = (attemptId) => `api/attempts/${attemptId}/answers`;
export const LIVE_LECTURE_QUIZ_STATUSES = (categoryId) =>
  `api/courses/categories/${categoryId}/quiz-status`;
export const CATEGORY_MY_ATTEMPT_STATUS = (id, type = "categories") =>
  `api/${type}/${id}/my-attempt-status`;
export const GET_CERTIFICATE = (id, type = "categories") =>
  `api/${type}/${id}/certificate`;
export const GENERATE_CERTIFICATE = (id, type = "categories") =>
  `api/${type}/${id}/certificate/dentist`;
// export const REGENERATE_CERTIFICATE = (attemptId) =>
//   `api/attempts/${attemptId}/certificate/regenerate`;
export const ATTEMPTS = "api/attempts";
export const ARCHIVE_ATTEMPT = (attemptId) =>
  `api/attempts/${attemptId}/archive`;
export const ATTEMPTED_ANSWERD = (attemptId) =>
  `/api/attempts/${attemptId}/attempted_answer`;
export const CREATE_QUESTION = (id, type = "categories") =>
  `api/${type}/${id}/question`;
export const GET_QUESTIONS = (id, type = "categories") =>
  `api/${type}/${id}/questions`;
export const UPDATE_QUESTION = (id, questionId, type = "categories") =>
  `api/${type}/${id}/question/${questionId}`;
export const REORDER_QUESTION = (id, questionId, type = "categories") =>
  `api/${type}/${id}/question/${questionId}/reorder`;
export const DELETE_QUESTIONS = (id, type = "categories") =>
  `api/${type}/${id}/questions`;
